<script lang="ts">
	import Button from '../../Button.svelte';
	export let options = [];
	export let incomeGroups = [];

	function onIncomeClick(ageGrp: string, event: Event) {
		event.preventDefault();
		if (incomeGroups.some((item) => item === ageGrp)) {
			incomeGroups = incomeGroups.filter((item) => item !== ageGrp);
		} else {
			const newincomeGroups = [...incomeGroups, ageGrp];
			incomeGroups = options.filter((item) => newincomeGroups.includes(item));
		}
	}

	function onAnyClick(event: Event) {
		event.preventDefault();
		incomeGroups = options.length === incomeGroups.length ? [] : options;
	}
</script>

<Button
	margin
	variant={options.length === incomeGroups.length || incomeGroups.length === 0
		? 'raised'
		: 'outlined'}
	on:click={onAnyClick}
>
	any
</Button>
{#each options as ageGrp}
	<Button
		margin
		variant={incomeGroups.some((x) => x === ageGrp) ? 'raised' : 'outlined'}
		on:click={(e) => onIncomeClick(ageGrp, e)}
	>
		{ageGrp}
	</Button>
{/each}
